// SOURCE UNIQUE de la checklist ANAH côté écran (T-242d) : « À compléter », Vue globale et onglet Conformité lisent le MÊME verdict,
// celui du moteur `check_anah_checklist` (GET /api/metier/agents/depot/checklist). Aucune liste de pièces n'est refaite ici.
import { useCallback, useEffect, useState } from "react";
import { API, getAuthHeaders } from "./helpers";

export function normaliserChecklist(data) {
  if (!data || !data.found) return null;
  return {
    score_pct: data.score_pct,
    required_total: data.required_total,
    required_present: data.required_present,
    verdict: data.verdict,
    present: data.pieces_presentes || [],
    missing_required: data.pieces_manquantes_obligatoires || [],
    missing_optional: data.pieces_manquantes_optionnelles || [],
    sources_used: data.sources_used || [],
  };
}

export async function chargerChecklistAnah(reference, tenantId) {
  if (!reference) return null;
  const res = await fetch(`${API}/api/metier/agents/depot/checklist?reference=${encodeURIComponent(reference)}`,
    { headers: getAuthHeaders(tenantId), credentials: "include" });
  return res.ok ? normaliserChecklist(await res.json()) : null;
}

const ids = (liste) => (liste || []).map((p) => p && p.id).filter(Boolean);

export const piecesManquantes = (checklist) => (checklist ? checklist.missing_required || [] : []);

// Le moteur « couvre » une pièce quand elle figure dans ses listes (présente ou manquante) : la ligne locale équivalente s'efface alors.
export const checklistCouvre = (checklist, pieceId) =>
  Boolean(checklist) && [...ids(checklist.present), ...ids(checklist.missing_required), ...ids(checklist.missing_optional)].includes(pieceId);

export const libellePieceManquante = (p) => `Pièce manquante : ${p.nom || p.id}`;

export function useChecklistAnah(reference, tenantId, actif = true) {
  const [checklist, setChecklist] = useState(null);
  const recharger = useCallback(async () => {
    if (!actif || !reference) { setChecklist(null); return null; }
    try {
      const c = await chargerChecklistAnah(reference, tenantId);
      setChecklist(c);
      return c;
    } catch (e) {
      console.error("[checklistAnah] chargement impossible:", e);
      return null;
    }
  }, [reference, tenantId, actif]);
  useEffect(() => { recharger(); }, [recharger]);
  return { checklist, recharger };
}
